import React from 'react';
import { LandingLayout } from '../../components/layouts';
import { TextField } from '@stax-core/truffle-components';
import { Link } from 'react-router-dom';
import {
  Button,
  DividerLine,
  FieldWrapper,
  GoogleButton,
  HaveAccount,
  Header,
  LayoutWithHeader,
  OffsetCenteredContent,
  Title,
} from './Authentication.style';
import GoogleIcon from '../../assets/img/google-icon.svg';
import StaxLogo from '../../assets/img/stax.svg';
import { Group } from '../../../components';

export const SignInPage = () => {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');

  const isDisabled = !email || !password;

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 4) {
      setPassword(e.target.value);
    } else {
      setPassword('');
    }
  };

  return (
    <LandingLayout reversed={false}>
      <LayoutWithHeader>
        <Header>
          <img src={StaxLogo} alt="Stax Logo" />
        </Header>
        <OffsetCenteredContent
          id="sign-in-page"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: 'spring', stiffness: 100 }}
          exit={{ opacity: 0, y: -20 }}
        >
          <div></div>
          <Title>Sign in to your account</Title>
          <form style={{ display: 'flex', flexDirection: 'column' }}>
            <FieldWrapper>
              <TextField
                onInput={handleEmailChange}
                label="Email"
                name="email"
                type={'email'}
              />
            </FieldWrapper>

            <FieldWrapper>
              <TextField
                onInput={handlePasswordChange}
                label="Password"
                name="password"
                type={'password'}
              />
            </FieldWrapper>
            <Button disabled={isDisabled} trackingId="gogurt-sign-in">
              Sign in
            </Button>

            <DividerLine>
              <span>or</span>
            </DividerLine>
            <GoogleButton trackingId="gogurt-google-sign-in">
              <img src={GoogleIcon} alt={'Google sign logo'} />
              &nbsp;&nbsp; Sign in with Google
            </GoogleButton>
          </form>
          <Group direction='column' justify='end'>
            <HaveAccount>
              Don't have an account? <Link to="/sign-up">Sign up</Link>
            </HaveAccount>
          </Group>
        </OffsetCenteredContent>
      </LayoutWithHeader>
    </LandingLayout>
  );
};

export default SignInPage;
